import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { observer } from 'mobx-react';
import Mmebers from './members/members';
import Payments from './payments/payments';
import { SubPageContainer } from '../appoint';

const Organization = observer(() => {
  return (
    <SubPageContainer maxWidth={false}>
      <Switch>
        <Route exact path="/organization/members" component={Mmebers} />
        <Route exact path="/organization/payments" component={Payments} />
      </Switch>
    </SubPageContainer>
  );
});

export default Organization;
